<template>
  <AppSection id="languages" :title="$getConst.pages.scope.jobs_logs" type="page">
    <b-form-group id="language" :label="$t($getConst.pages.scope.scopes)" label-for="language-input">
      <multiselect
        v-model="scope"
        track-by="id"
        label="name"
        :placeholder="$t(this.$getConst.pages.form.select_option)"
        :options="$store.getters['auth/allScopes']"
        :show-labels="false"
        :searchable="true"
        @input="changeScope"
      >
      </multiselect>
    </b-form-group>
    <AppDataTable
      ref="commandLogsTable"
      :fields="fields"
      :end-point="endPoint"
    >

      <template v-slot:properties="item">
        <b-link @click="showPropertiesDetails(item.row)" v-b-tooltip.hover
                  :title="$getConst.pages.button.show_more"><i :class="$getConst.icons.externalLink + ' text-primary'"></i></b-link>
      </template>

      <template v-slot:details="item">
        <template v-if="item.data.length > 10">
          {{ item.data.substr(0, 30)  }} ...
          <b-link @click="showDetails(item.row)" v-b-tooltip.hover
                  :title="$getConst.pages.button.show_more"><i :class="$getConst.icons.externalLink + ' text-primary'"></i></b-link>
        </template>
      </template>

    </AppDataTable>
    <ShowLogPropertiesDetailsModal v-if="log" :log="log" :id="propertiesDetailsModal" size="xl"></ShowLogPropertiesDetailsModal>
    <ShowLogDetailsModal v-if="log" :log="log" :id="detailsModal" size="xl"></ShowLogDetailsModal>
  </AppSection>
</template>

<script>
  import AppSection from "../../../../components/common/sections/AppSection";
  import AppDataTable from "../../../../components/common/table/AppDataTable";
  import ShowLogPropertiesDetailsModal from "./ShowLogPropertiesDetailsModal";
  import ShowLogDetailsModal from "./ShowLogDetailsModal";

  export default {
    name: "commandLogs",
    components: {ShowLogDetailsModal, ShowLogPropertiesDetailsModal, AppSection, AppDataTable},
    data() {
      return {
        endPoint: null,
        fields: [
          {key: 'log_name', label: 'name', sortable: true, filterable: true},
          {key: 'description', sortable: true, filterable: true},
          {key: 'properties', sortable: true, filterable: false},
          {key: 'status', sortable: true, filterable: true},
          {key: 'details', sortable: true, filterable: true},
          {key: 'created_at', sortable: true, filterable: 'date'},
        ],
        scope: null,
        scopeIds: null,
        propertiesDetailsModal: 'properties-details-modal',
        detailsModal: 'details-modal',
        log: null
      }
    },
    created() {
      this.$store.getters['auth/allScopes'].forEach(scope => {
        this.scopeIds = this.scopeIds + "," + scope.id;
      });
      this.scopeIds = this.scopeIds.substring(5)
      this.endPoint = '/commandActivityLogs/' + this.scopeIds;
    },
    methods: {
      changeScope() {
        if (this.scope) {
          this.endPoint = '/commandActivityLogs/' + this.scope.id;
        } else {
          this.endPoint = '/commandActivityLogs/' + this.scopeIds;
        }
      },
      showPropertiesDetails(log) {
        this.log = log;
        this.$nextTick(() => this.$bvModal.show(this.propertiesDetailsModal));
      },
      showDetails(log) {
        this.log = log;
        this.$nextTick(() => this.$bvModal.show(this.detailsModal));
      },
    },
  }
</script>
